<template>
  <div class="con">
    <div class="con-inner">
      <h2 class="con-head">{{ name }}用户注册隐私协议</h2>
      <div>
        <div
          v-for="(item, index) in textLines"
          :key="index"
          :class="{ paragraph: item.paragraph, title: item.title }"
        >
          {{ textFilter(item.text) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "中国机械总院集团武汉材料保护研究所有限公司公共服务平台",
      subName: "公共服务平台",
      textLines: [
        {
          paragraph: true,
          text: `尊敬的{name}注册用户，感谢您使用我们的产品和服务。《{name}用户注册隐私协议》（以下简称“本协议”）适用于{name}与用户之间关于使用{name}相关服务所订立的协议，
          本协议内容包括协议正文及所有已经在{name}发布和将来可能发布的各类规则和声明，所有规则和声明为本协议不可分割的一部分，与协议正文具有同等法律效力。`,
        },
        {
          paragraph: true,
          text: `在使用{name}服务之前，您应当认真阅读并遵守本协议，请您务必审慎阅读、充分理解各条款内容，
          特别是免除或者限制责任的条款、争议解决和法律适用条款。免除或者限制责任的条款可能将以加粗字体显示，您应重点阅读。如您对条款有任何疑问的，应向{name}咨询。
          届时您不应以未阅读本协议的内容或者未获得{name}对您问询的解答等理由，主张本协议无效，或要求撤销本协议。`,
        },
        {
          title: true,
          text: "一、 定义",
        },
        {
          paragraph: true,
          text: `用户，包含注册用户和非注册用户。注册用户是指通过网址完成全部注册程序后，使用{name}服务的用户。
          非注册用户是指未进行注册、直接登录网址或通过其他网站进入使用{name}服务的用户。`,
        },
        {
          title: true,
          text: "二、用户注册隐私协议的确认和接纳",
        },
        {
          paragraph: true,
          text: `2.1 本协议内容包括协议正文及所有{name}已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与条款正文具有同等法律效力。
          除另行明确声明外，任何{name}及其关联公司和网站提供的服务均适用本协议。`,
        },
        {
          paragraph: true,
          text: `2.2 当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，或以其他{name}允许的方式实际使用{name}服务时，即表示您已充分阅读、理解并接受本协议的全部内容。`,
        },
        {
          paragraph: true,
          text: `2.3 当您使用{name}提供的服务时，表明您已知晓本协议中的所有条款，并同意受其约束。`,
        },
        {
          paragraph: true,
          text: `2.4 本协议在必要时将进行更新，每次改动都会在{name}上发布更新通知，发布立即生效。如果您拒绝接受新的条款，
          您必须放弃使用{name}提供的服务；若您继续使用{name}提供的服务，则表明您已接受新的条款。`,
        },
        {
          paragraph: true,
          text: `2.5 {name}有权根据国家法律法规的更新，产品和服务规则的调整需要不时地制定、修改本协议及各类规则，
          并以网站公示或者其他公开的方式进行公示。如您继续使用{name}服务的，即表示您接受经修订的条款和规则。`,
        },
        {
          title: true,
          text: `三、用户`,
        },
        {
          paragraph: true,
          text: `3.1 在注册时，您应当按照法律法规要求，或注册页面的提示，准确填写并及时更新您提供的电子邮件地址、联系电话、联系地址、邮政编码等联系方式，以便{name}或其他相关人员与您进行有效联系。
          如您的资料发生变更，您应及时更新您的资料，以使之真实、完整和准确。因通过您所提交的联系方式无法与您取得联系，导致您在使用本平台服务过程中产生任何损失或增加费用的，应由您完全自行承担。`,
        },
        {
          paragraph: true,
          text: `3.2 用户提供的个人信息资料错误、不实、过时或不完整，我们有权保留结束用户使用{name}用户服务的权利。
          在用户需要{name}帮助时，{name}将因不能确认用户身份及其账号的使用权利，导致不能够向其提供相应的帮助，并且由此带来的一切后果均由用户自己承担。`,
        },
        {
          paragraph: true,
          text: `3.3 您自愿接受{name}不定时地向您的信箱发送信息。
          如果因您提供的资料不准确，{name}保留修改直至删除您所发布的虚假、违法、有损他人名誉和利益、侵权的一切信息的权利和结束用户使用{name}用户服务的权利。`,
        },
        {
          title: true,
          text: `四、注册`,
        },
        {
          paragraph: true,
          text: `4.1 您确认，在您完成注册程序或以其他{name}允许的方式实际使用{name}服务时，您应当是具备相应民事行为能力的自然人、法人或其他组织。
          若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且{name}有权注销您的账户，并向您及您的监护人索偿。`,
        },
        {
          paragraph: true,
          text: `4.2 {name}非常重视对青少年个人信息搜集和使用的安全性的保护。{name}建议，任何未满18周岁的未成年人参加网上活动应事先取得其监护人（以下简称"监护人"）的同意并遵守《青少年网络文明公约》。`,
        },
        {
          paragraph: true,
          text: `4.3 在您签署本协议，完成注册程序时，{name}会向您提供唯一编号的{name}账户和密码。您应对您的账户和密码的安全，以及对通过您的账户和密码实施的行为负责。
          除非有法律规定或行政司法机关的指令，且征得{name}的同意，否则，账户和密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。
          如果发现任何人不当使用您的账户或有任何其他可能危及您的账户安全的情形时，您应当立即以有效方式通知{name}，要求{name}暂停相关服务。
          您理解{name}对您的请求采取行动需要合理时间，{name}对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。`,
        },
        {
          paragraph: true,
          text: `4.4 用户将因自身的等级不同，享有不同的权限，另外，每个用户都要对其账号中的所有活动和事件负全部责任。用户可随时发出指示改变你的密码，也可以结束旧的账户重开一个新账户。
          用户若发现有任何非法使用自己的账号或存在其他安全漏洞的情况，应当立即通知{name}。`,
        },
        {
          title: true,
          text: `四、服务说明`,
        },
        {
          paragraph: true,
          text: `用户对使用{name}用户服务承担风险，包括但不限于财务和投资风险，{name}对此不作任何类型的担保，不论该担保是明确的或隐含的，{name}不担保服务一定能满足用户的要求，
          用户须明确了解并同意因以下原因而造成之损失，包括但不限于利润、商誉、使用、资料损失或其他无形损失，{name}不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿本服务无法使用，
          包括但不限于服务中断，对于本服务的及时性安全性、出错或丢失的发生；经本服务购买之任何商品、资料或接受的服务，或接收之讯息；
          用户的资料或资料的传输遭到不获授权的存取或变造；用户对于产品资料的维护和变更本服务其他相关事宜。`,
        },
        {
          title: true,
          text: `四、服务说明`,
        },
        {
          paragraph: true,
          text: `用户对使用{name}用户服务承担风险，包括但不限于财务和投资风险，{name}对此不作任何类型的担保，不论该担保是明确的或隐含的，
          {name}不担保服务一定能满足用户的要求，用户须明确了解并同意因以下原因而造成之损失，包括但不限于利润、商誉、使用、资料损失或其他无形损失，
          {name}不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿本服务无法使用，包括但不限于服务中断，对于本服务的及时性安全性、出错或丢失的发生；
          经本服务购买之任何商品、资料或接受的服务，或接收之讯息；用户的资料或资料的传输遭到不获授权的存取或变造；用户对于产品资料的维护和变更本服务其他相关事宜。`,
        },
        {
          title: true,
          text: `六、用户管理`,
        },
        {
          paragraph: true,
          text: `6.1 用户独立承担其在{name}用户服务发布内容的责任。用户对{name}用户服务提供的服务的接受，
          是根据所有适用于{name}用户服务的国际法律标准、国家法律和地方法律的。用户必须遵循：`,
        },
        {
          paragraph: true,
          text: "（1）发布资料必须符合中国有关法律法规；",
        },
        {
          paragraph: true,
          text: "（2）使用{name}用户服务且不作其他非法用途；",
        },
        {
          paragraph: true,
          text: "（3）不干扰或混乱{name}用户服务网络服务；",
        },
        {
          paragraph: true,
          text: `包括：用户须承诺不传输、发布任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、暴力等信息资料。
          另外，用户也不能传输、发布任何教唆他人构成犯罪行为的资料；不能传输、发布助长国内不利条件和涉及国家安全的资料；不能传输、发布任何不符合国际法律、国家法律和当地法规的资料。`,
        },
        {
          paragraph: true,
          text: `6.2 若用户的行为不符合以上提到的用户注册隐私协议，{name}有权独立判断立即取消该用户服务账号的使用权。`,
        },
        {
          title: true,
          text: `七、结束服务`,
        },
        {
          paragraph: true,
          text: `7.1 您同意，{name}基于网站服务的安全性，有权中止向您提供部分或全部{name}服务，暂时冻结您的账户，待安全问题解决后及时恢复，并对中止、冻结及恢复的事实及时通知。
          如果网站的安全问题是由于您的违法行为引起，{name}有终止向您提供部分或全部{name}服务，永久冻结（注销）您的账户，并有权向您对损失进行索赔。`,
        },
        {
          paragraph: true,
          text: `7.2 您有权向{name}要求注销您的账户，经{name}审核同意的，{name}注销您的账户。届时，您与{name}基于本协议的合同关系即终止。
          您的账户被注销后，{name}没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。`,
        },
        {
          paragraph: true,
          text: `7.3 您同意，您与{name}的条款关系终止后，{name}仍享有下列权利：`,
        },
        {
          paragraph: true,
          text: `（1）继续保存您未及时删除的注册信息及您使用{name}服务期间发布的所有信息至法律规定的记录保存期满；`,
        },
        {
          paragraph: true,
          text: `（2）您在使用{name}服务期间存在违法行为或违反本协议和/或规则的行为的，{name}仍可依据本协议向您主张权利。`,
        },
        {
          title: true,
          text: `八、赔偿`,
        },
        {
          paragraph: true,
          text: `{name}用户服务数据库中用户信息内容包括：文字、软件、声音、相片、录像、图表；在广告中全部内容；电子邮件的全部内容；{name}为用户提供的商业信息，
          所有这些版权、商标、标签、著作等知识产权均受权相关法律的保护。所以，用户只能在{name}和广告商授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与该内容有关的任何派生产品。
          对由于用户使用{name}的信息、违反用户条款、违反知识产权的保护或损害其他个人或实体的权益而造成{name}、员工、所有者及代理卷入法律诉讼中，用户必须予以赔偿。`,
        },
        {
          title: true,
          text: `九、责任声明`,
        },
        {
          paragraph: true,
          text: `9.1 {name}负责向您提供{name}服务。对本网站的内容，我们已尽全力的审核，但我们对{name}服务不作任何明示或暗示的保证，包括但不限于{name}服务的适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途。
          同时，{name}也不对全{name}服务所涉及的技术及信息的有效性、准确性、正确性、可靠性、稳定性、完整性和及时性作出任何承诺和保证。`,
        },
        {
          paragraph: true,
          text: `9.2 {name}无法杜绝可能存在风险和瑕疵。您应谨慎判断确定相关信息的真实性、合法性和有效性，并注意保留相应的证据以利于维权，如可能，尽量采用网站建议的方式接受服务。
          {name}不为任何用户发布的内容负责，包括但不限于任何内容不承担任何错误或遗漏而衍生的任何损失或损害。`,
        },
        {
          paragraph: true,
          text: `9.3 您同意在发本网站任何内容不符合法律规定，或不符合本用户条款规定的，您有义务及时通知{name}。如果您发现您的个人信息被盗用，或者您的版权或者其他权利被侵害，请将此情况告知{name}并同时提供如下信息和材料：`,
        },
        {
          paragraph: true,
          text: `（1）侵犯您权利的信息的网址，编号或其他可以找到该信息的细节；`,
        },
        {
          paragraph: true,
          text: `（2）您是所述的版权或者其他权利的合法拥有者的权利证明；`,
        },
        {
          paragraph: true,
          text: `（3）您的联系方式，包括联系人姓名，地址，电话号码和电子邮件。 经审查得到证实的，我们将及时删除相关信息。
          我们仅接受邮寄、电子邮件或传真方式的书面侵权通知。情况紧急的，您可以通过客服电话先行告知，我们会视情况采取相应措施。`,
        },
        {
          paragraph: true,
          text: `9.4 您了解并同意，{name}不对因下述任一情况而导致您的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿 ：`,
        },
        {
          paragraph: true,
          text: `（1）在任何情况下，对于使用{name}服务内容或无法进入本网站而导致的任何直接的、间接的、附带的、给第三人造成的损失。`,
        },
        {
          paragraph: true,
          text: `（2）第三方未经批准使用您的账户或更改您的数据`,
        },
        {
          paragraph: true,
          text: `（3）您对{name}服务的误解；`,
        },
        {
          paragraph: true,
          text: `（4）所有用户在本站发表的商业信息、个人信息、留言、评论、论坛话题等，均不代表本网站以及中国机械总院集团武汉材料保护研究所有限公司的立场，与我们无关，相关责任作者自负后果，并且我们有权对上述商业信息、个人信息、留言、评论、论坛话题进行删除。`,
        },
        {
          paragraph: true,
          text: `（5）任何非因{name}的原因而引起的与{name}服务有关的其它损失。`,
        },
        {
          paragraph: true,
          text: `9.5 您应当严格遵守本协议及{name}发布的其他条款、活动规则，因您违反条款或规则的行为给第三方、或{name}造成损失的，您应当承担全部责任。`,
        },
        {
          title: true,
          text: `十、不可抗力`,
        },
        {
          paragraph: true,
          text: `对于本公司合理控制范围以外的原因，包括但不限于自然灾害、物质短缺或定量配给、暴力、战争、政府行为、通讯或其他设施故障或严重伤亡事故等，致使本公司延迟或未能履约的，{name}不对您承担任何责任。`,
        },
        {
          title: true,
          text: `十一、法律适用与管辖`,
        },
        {
          paragraph: true,
          text: `11.1 本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，如无相关法律规定的，则应参照通用国际商业惯例和（或）行业惯例。`,
        },
        {
          paragraph: true,
          text: `11.2 因本协议或本公司服务所引起或与其有关的任何争议应提交本公司所在地区的人民法院进行诉讼。本协议的解释权及对本网站使用的解释权最终归结于中国机械总院集团武汉材料保护研究所有限公司。`,
        },
      ],
    };
  },
  methods: {
    textFilter(val) {
      return val
        .replaceAll("{name}", this.name)
        .replaceAll("{subName}", this.subName);
    },
  },
};
</script>
<style scoped lang="scss">
@import "./common.scss";
</style>
